import {
  bodySmallTypography,
  Container,
  pxToRem,
  spacing2,
  Typography,
} from '@leaftrade/leaftrade-component-library';
import PropTypes from 'prop-types';
import React from 'react';
import { STOREFRONT_MODE } from '../../../constants';
import { BadgeWrapper } from './StorefrontModeBadge.styles';

const StorefrontModeBadge = ({ directPayEnabled, storefrontMode }) => {
  const modeString = () => {
    switch (storefrontMode) {
      case STOREFRONT_MODE.COMING_SOON:
        return 'Coming Soon';
      case STOREFRONT_MODE.INACTIVE:
        return 'Inactive';
      case STOREFRONT_MODE.READ_ONLY_MENU:
        return 'View Only';
      default:
        return '';
    }
  };

  const showBadgeContainer =
    directPayEnabled || storefrontMode !== STOREFRONT_MODE.PURCHASING_ACTIVE;

  return showBadgeContainer ? (
    <Container
      sx={{
        flexDirection: 'column',
        gap: spacing2,
        position: 'absolute',
        left: `-${pxToRem(8)}`,
      }}
    >
      {storefrontMode &&
        storefrontMode !== STOREFRONT_MODE.PURCHASING_ACTIVE && (
          <BadgeWrapper
            data-testid='storefront-mode-badge--component--div'
            storefrontMode={storefrontMode}
          >
            <Typography bodyStyle={bodySmallTypography} component='span'>
              {modeString()}
            </Typography>
          </BadgeWrapper>
        )}
      {directPayEnabled && (
        <BadgeWrapper
          data-testid='direct-pay-enabled-badge--component--div'
          directPayEnabled={directPayEnabled}
        >
          <Typography bodyStyle={bodySmallTypography} component='span'>
            Direct Pay Available
          </Typography>
        </BadgeWrapper>
      )}
    </Container>
  ) : null;
};

StorefrontModeBadge.defaultProps = {
  directPayEnabled: false,
};

StorefrontModeBadge.propTypes = {
  directPayEnabled: PropTypes.bool,
  storefrontMode: PropTypes.string.isRequired,
};

export default StorefrontModeBadge;
